import { render, staticRenderFns } from "./MobilePayment.vue?vue&type=template&id=23636cd7&"
import script from "./MobilePayment.vue?vue&type=script&lang=js&"
export * from "./MobilePayment.vue?vue&type=script&lang=js&"
import style0 from "./MobilePayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports